import React, { FC } from 'react'
import { FixedLayout } from 'components/Layout'
import { RegisterTemplate } from 'components/Templates'

const Register: FC = () => {
  return (
    <FixedLayout title={'アカウント登録'}>
      <RegisterTemplate />
    </FixedLayout>
  )
}

export default Register
